import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_AUTH_API
  || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8080/api');

export interface Cohort {
  cohort_id: number;
  bootcamp_id: string;
  cohort_name: string;
  cohort_code: string;
  starts_at: string | null;
  ends_at: string | null;
  is_active: boolean;
  show_theoric_videos: boolean;
  show_group_videos: boolean;
  weeks_theoric_unlocked: number;
  weeks_group_unlocked: number;
  enrolled_at?: string;
}

export async function fetchMyCohorts(): Promise<Cohort[]> {
  const token = getToken();
  if (!token) return [];

  const base = API_BASE.replace(/\/auth\/?$/, '');

  const res = await fetch(`${base}/bootcamp/my-cohorts.php`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) return [];

  const data = await res.json();
  return data.cohorts ?? [];
}

// --- Admin helpers ---

export async function fetchAllCohorts(token: string): Promise<any[]> {
  const base = API_BASE.replace(/\/auth\/?$/, '');
  const res = await fetch(`${base}/admin/cohorts.php`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return [];
  const data = await res.json();
  return data.cohorts ?? [];
}

export async function fetchUserCohorts(token: string, userId: number): Promise<Cohort[]> {
  const base = API_BASE.replace(/\/auth\/?$/, '');
  const res = await fetch(`${base}/admin/cohorts.php?user_id=${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return [];
  const data = await res.json();
  return data.cohorts ?? [];
}

export async function assignUserCohort(token: string, userId: number, cohortId: number): Promise<boolean> {
  const base = API_BASE.replace(/\/auth\/?$/, '');
  const res = await fetch(`${base}/admin/cohorts.php`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, cohort_id: cohortId }),
  });
  return res.ok;
}

export async function removeUserCohort(token: string, userId: number, cohortId: number): Promise<boolean> {
  const base = API_BASE.replace(/\/auth\/?$/, '');
  const res = await fetch(`${base}/admin/cohorts.php?user_id=${userId}&cohort_id=${cohortId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.ok;
}
